import get from 'lodash/get';

export const getOutcomeDisplayText = evaluation => {
  if (evaluation.outcome) {
    return evaluation.outcome;
  }

  if (evaluation.evaluation_type === 'reconciliation') {
    return 'No Outcome';
  }

  return 'Pending';
};

const populatedDiligenceMatchData = response => {
  const matchInfo = [];
  const matchedData = get(response, 'diligence.watchlists.matches', []);
  matchedData.forEach(match => {
    if (match.details) {
      matchInfo.push(match);
    }
  });
  return matchInfo;
};

// pulls out watchlist match data for WatchlistData component
const populateWatchlistMatchData = response => {
  const matchInfo = [];
  if (response) {
    Object.keys(response).forEach(index => {
      const fetchedData = response[index].data;
      if (fetchedData && {}.hasOwnProperty.call(fetchedData, 'matches')) {
        const matchedData = fetchedData.matches;
        if (Array.isArray(matchedData)) {
          matchedData.forEach(match => {
            if (match.details) {
              matchInfo.push(match);
            }
          });
        }
      }
    });
  }
  return matchInfo;
};

export const constructWatchlistMatchDataObject = response => {
  const newFormattedResponse = response ? response.formatted_responses : null;
  // handle new format where diligence contains all the watchlist hit matches
  const matchInfoDiligence = populatedDiligenceMatchData(response);
  let matchInfo = populateWatchlistMatchData(newFormattedResponse);
  // older format where formattedResponse contains all the watchlist hit matches
  if (matchInfo.length < matchInfoDiligence.length) {
    matchInfo = matchInfoDiligence;
  }
  return matchInfo;
};
